import React from 'react';
import { Modal } from 'react-bootstrap';

import ModalContent from 'components/Granel/boletos/Modal';
import type { BankSlipModalProps } from 'components/Granel/boletos/Modal/types';
import type { BankSlipRow } from 'pages/BankSlip/utils/bankSlipDisplay';

const BankSlipModalContent =
  ModalContent as React.ComponentType<BankSlipModalProps>;

export type BankSlipViewModalProps = {
  open: boolean;
  invoice: BankSlipRow['invoice'] | null;
  installment: BankSlipRow['installment'] | null;
  onClose: () => void;
  setCloseModal?: (value: boolean) => void;
  showMobileMode?: boolean;
};

const BankSlipViewModal = ({
  open,
  invoice,
  installment,
  onClose,
  setCloseModal,
  showMobileMode = false,
}: BankSlipViewModalProps): JSX.Element | null => {
  if (!invoice || !installment) return null;

  return (
    <Modal
      show={open}
      onHide={onClose}
      size="lg"
      dialogClassName="modal-90w"
      aria-labelledby="visualizacao-do-boleto"
      animation={false}
      centered
    >
      <BankSlipModalContent
        close={onClose}
        payment={invoice}
        installment={{
          ...installment,
          amountOriginal:
            installment.amountOriginal === undefined
              ? undefined
              : Number(installment.amountOriginal),
        }}
        setCloseModal={setCloseModal}
        showMobileMode={showMobileMode}
      />
    </Modal>
  );
};

export default BankSlipViewModal;
